import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';

// Fallback data (used if Firestore is empty or fails)
const fallbackTweets = [
  {
    id: 1,
    date: "May 1, 2020",
    content: "Tesla stock price is too high imo",
    impact: "Tesla stock dropped 10% ($14B market cap loss)",
    category: "market"
  },
  {
    id: 2,
    date: "Aug 7, 2018",
    content: "Am considering taking Tesla private at $420. Funding secured.",
    impact: "Led to SEC fraud charges and $40M settlement",
    category: "legal"
  },
  {
    id: 3,
    date: "Mar 6, 2020",
    content: "The coronavirus panic is dumb",
    impact: "Widely criticized by health experts",
    category: "controversy"
  },
  {
    id: 4,
    date: "Jan 29, 2021",
    content: "#bitcoin",
    impact: "Bitcoin surged 20% following this single-word tweet",
    category: "market"
  },
  {
    id: 5,
    date: "May 13, 2021",
    content: "Tesla has suspended vehicle purchases using Bitcoin... concerned about rapidly increasing use of fossil fuels for Bitcoin mining",
    impact: "Bitcoin dropped 17% in hours",
    category: "market"
  },
  {
    id: 6,
    date: "Dec 22, 2024",
    content: "The AfD is the only hope for Germany",
    impact: "Sparked international debate over election interference",
    category: "political"
  },
  {
    id: 7,
    date: "Nov 2022",
    content: "The bird is freed",
    impact: "First tweet after Twitter acquisition, signaling policy changes",
    category: "platform"
  },
  {
    id: 8,
    date: "Apr 2022",
    content: "Next I'm buying Coca-Cola to put the cocaine back in",
    impact: "Viral joke tweet during Twitter acquisition saga",
    category: "humor"
  }
];

const categoryColors = {
  market: '#f59e0b',
  legal: '#ef4444',
  controversy: '#8b5cf6',
  political: '#3b82f6',
  platform: '#10b981',
  humor: '#ec4899'
};

const TweetsFeed = () => {
  const [tweets, setTweets] = useState(fallbackTweets);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTweets = async () => {
      try {
        const tweetsQuery = query(
          collection(db, 'tweets'),
          orderBy('order', 'asc'),
          limit(20)
        );
        const snapshot = await getDocs(tweetsQuery);
        
        if (!snapshot.empty) {
          const firestoreTweets = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setTweets(firestoreTweets);
        }
        // If empty, fallback data is already set
      } catch (error) {
        console.log('Using fallback tweets data');
        // Fallback data already set
      } finally {
        setLoading(false);
      }
    };

    fetchTweets();
  }, []);

  return (
    <div className="tweets-feed">
      <h3>Notable Tweets</h3>
      <p className="tweets-subtitle">Tweets that moved markets, sparked lawsuits, or made headlines</p>
      {loading ? (
        <div className="loading-placeholder">Loading tweets...</div>
      ) : (
        <div className="tweets-list">
          {tweets.map(tweet => (
            <div key={tweet.id} className="tweet-card">
              <div className="tweet-header">
                <span className="tweet-date">{tweet.date}</span>
                <span 
                  className="tweet-category" 
                  style={{ backgroundColor: categoryColors[tweet.category] || '#6b7280' }}
                >
                  {tweet.category}
                </span>
              </div>
              <blockquote className="tweet-content">
                "{tweet.content}"
              </blockquote>
              <div className="tweet-impact">
                <strong>Impact:</strong> {tweet.impact}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TweetsFeed;
